import * as D from 'io-ts/Decoder';

export const ACTrainCategoryDecoder = D.string;
